import { easeInOut, animate, KeyframeOptions } from 'popmotion'
import styler from 'stylefire'

export type Value = { [key: string]: number | string }

type AnimationProps = {
	el: HTMLElement
	from: KeyframeOptions<Value>['from']
	to: KeyframeOptions<Value>['to']
	duration?: number
	onComplete?: () => void
}

// export const useAnimation = (el: HTMLElement, from: TweenProps['from'], to: TweenProps['to'], duration = 300) => {
export const useAnimation = ({ el, from, to, duration = 300, onComplete }: AnimationProps) => {
	const newStyler = styler(el)
	animate<Value>({
		from,
		to,
		duration,
		ease: easeInOut,
		onUpdate: newStyler.set,
		onComplete,
	})
}
